import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { VngButtonComponent, VngButtonVariant } from "@vengreso/angular-components";
import {
  NotificationActionOption,
  NotificationActionsContent,
  NotificationTemplate,
} from "src/app/core/models/notification.model";
import { NotificationTemplateRenderer } from "../notification-template-renderer";

/**
 * Renders `{kind: "actions", content: {title, body?, actions: [{key, label,
 * style?}]}}` — e.g. an Accept/Reject invitation prompt. Clicking an action
 * emits `respond` with `{ action: key }`, which `NotificationItemComponent`
 * forwards to `AppNotificationService.respond(id, payload)`.
 */
@Component({
  selector: "app-notification-actions-renderer",
  standalone: true,
  imports: [CommonModule, VngButtonComponent],
  templateUrl: "./notification-actions-renderer.component.html",
  styleUrls: ["../notification-templates.scss"],
})
export class NotificationActionsRendererComponent implements NotificationTemplateRenderer {
  @Input() template!: NotificationTemplate;
  @Output() respond = new EventEmitter<Record<string, unknown>>();

  private get content(): NotificationActionsContent {
    return this.template?.content as unknown as NotificationActionsContent;
  }

  get title(): string {
    return this.content?.title ?? "";
  }

  get body(): string | undefined {
    return this.content?.body;
  }

  get actions(): NotificationActionOption[] {
    return this.content?.actions ?? [];
  }

  variantFor(action: NotificationActionOption): VngButtonVariant {
    if (action.style === "danger") return "destructive";
    if (action.style === "secondary") return "outline";
    return "primary";
  }

  choose(action: NotificationActionOption): void {
    this.respond.emit({ action: action.key });
  }
}
